import { render, staticRenderFns } from "./help.vue?vue&type=template&id=f4105e54&scoped=true"
import script from "./help.vue?vue&type=script&lang=js"
export * from "./help.vue?vue&type=script&lang=js"
import style0 from "./help.vue?vue&type=style&index=0&id=f4105e54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4105e54",
  null
  
)

export default component.exports